import React from 'react';
import PropTypes from 'prop-types';

const TitleAccessibility = ({ title }) => (
  <h1
    style={{
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: '1px',
      whiteSpace: 'nowrap',
    }}
  >
    {title}
  </h1>
);

TitleAccessibility.propTypes = {
  title: PropTypes.string.isRequired,
};

export default TitleAccessibility;
